import React, { FC } from 'react'
import Image from 'next/image'
import { Box, Text, useDisclosure, VStack } from '@chakra-ui/react'
import { H2Title, ListWithIcons } from 'src/uikit'
import GenericModalContainer from 'src/containers/GenericModalContainer'

import { ArrowForwardIcon } from '@chakra-ui/icons'

interface Props {
  image: string
  imageAlt: string
  itemsTitle: string
  items: Array<string>
  descriptionTitle: string
  description: string
  hrefTitle: string
  content: { title: string, text: string }
}

const HowNltWorksSectionMobile: FC<Props> = ({
  image,
  imageAlt,
  itemsTitle,
  items,
  description,
  descriptionTitle,
  hrefTitle,
  content,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return <VStack spacing={-130} align="stretch">
    <Box bg="primaryGreen.800" p="l" pb="8rem" pos="relative">
      <H2Title mr="5" mb="7" fontSize="1.5rem" lineHeight="1.938rem">{descriptionTitle}</H2Title>
      <Text
        fontFamily="Montserrat-Medium"
        fontSize="1rem"
        lineHeight="1.425rem"
        textAlign="left"
        color="baseWhite"
        mt=".75rem"
      >
        {description}
      </Text>
    </Box>
    <Box p="l" zIndex="2">
      <Image
        src={image}
        alt={imageAlt}
        width="593"
        height="358"
        objectFit="contain"
        loading="lazy"
        decoding="async"
        className="rounded"
      />
    </Box>
    <Box bg="baseWhite" p="l" pt="8rem" textAlign="left">
      <H2Title color="baseDark" fontSize="1.125rem" lineHeight="1.463rem">{itemsTitle}</H2Title>
      <ListWithIcons items={items} color="baseDark" fontSize="0.875rem" />
      <Text
        fontFamily="Montserrat-Medium"
        color="baseDark"
        onClick={onOpen}
      >
        {hrefTitle} <ArrowForwardIcon />
      </Text>
      <GenericModalContainer isOpen={isOpen} onClose={onClose} title={content.title}>
        {content.text}
      </GenericModalContainer>
    </Box>
  </VStack>
}

export default HowNltWorksSectionMobile
